export default __webpack_public_path__ + "img/0e8d91d664fe185f6b9138a11d01d438.jpg";